import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const ProcessSection = ({ steps }) => {
  const sectionRef = useRef(null);
  const processSteps = steps || [
    {
      number: "01",
      title: "Share Your Design",
      description: "Send us your logo, artwork, or design concept. We accept all major file formats and work with images of any quality.",
      icon: "📤"
    },
    {
      number: "02",
      title: "Precision Digitizing",
      description: "We convert your design into a high-quality embroidery file using professional software and years of expertise.",
      icon: "⚡"
    },
    {
      number: "03",
      title: "Quality Assurance",
      description: "Every file undergoes rigorous testing and quality checks to ensure perfect stitch-out results.",
      icon: "✓"
    },
    {
      number: "04",
      title: "Fast Delivery",
      description: "Receive your ready-to-use embroidery files in all required formats with free revisions included.",
      icon: "🚀"
    }
  ];

  useEffect(() => {
    const ctx = gsap.context(() => {
      // Animate section title
      gsap.from('.process-main-title', {
        scrollTrigger: {
          trigger: '.process-main-title',
          start: 'top 80%',
        },
        y: 50,
        opacity: 0,
        duration: 1,
        ease: 'power3.out'
      });

      // Animate process cards with stagger
      gsap.from('.process-card', {
        scrollTrigger: {
          trigger: '.process-grid',
          start: 'top 70%',
        },
        y: 100,
        opacity: 0,
        duration: 0.8,
        stagger: 0.2,
        ease: 'power3.out'
      });

      // Animate connecting lines
      gsap.from('.process-line', {
        scrollTrigger: {
          trigger: '.process-grid',
          start: 'top 70%',
        },
        scaleX: 0,
        duration: 1.5,
        stagger: 0.3,
        ease: 'power2.inOut'
      });

    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section ref={sectionRef} className="process-section position-relative">
      <div className="process-bg-overlay"></div>
      <div className="container">
        <div className="row justify-content-center mb-5">
          <div className="col-lg-8 text-center">
            <h2 className="process-main-title">Our Seamless 4 Step Process</h2>
          </div>
        </div>

        <div className="process-grid">
          {processSteps.map((step, index) => (
            <div key={index} className="process-card-wrapper">
              <div className="process-card">
                <div className="process-card-inner">
                  <div className="process-number-wrapper">
                    <span className="process-number">{step.number}</span>
                    <div className="number-glow"></div>
                  </div>
                  
                  <div className="process-icon">
                    <span className="icon-emoji">{step.icon}</span>
                    <div className="icon-circle"></div>
                    <div className="icon-circle-outer"></div>
                  </div>
                  
                  <h3 className="process-title">{step.title}</h3>
                  <p className="process-description">{step.description}</p>
                  
                  <div className="process-card-shine"></div>
                </div>
              </div>
              
              {index < processSteps.length - 1 && (
                <div className="process-line">
                  <div className="line-dots">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;